// extracted by mini-css-extract-plugin
export var center = "_4w-2";
export var clickableRow = "_4w-5";
export var expandedRow = "_4w-7";
export var hoverable = "_4w-4";
export var left = "_4w-1";
export var right = "_4w-3";
export var row = "_4w-0";
export var selectedRow = "_4w-6";
export var summaryRow = "_4w-8";